export default __webpack_public_path__ + "static/media/award-4.665aa010.png";